module.exports = __webpack_public_path__ + "static/media/banner-assinatura-mobile.cfa32b00.jpg";